<template>
  <PanelPage ref="useAlerts" :loading-overlay="loadingOverlay">
    <v-card class="mb-6">
      <v-card-title>Create Ipsum</v-card-title>
      <v-form @submit.prevent="submit" @reset="handleReset">
        <v-card-text>
          <v-text-field
            v-model="form.alias.value.value"
            :error-messages="form.alias.errorMessage.value"
            label="Name/Alias of the Ipsum"
          />
          <v-text-field
            v-model="form.token.value.value"
            :error-messages="form.token.errorMessage.value"
            label="TOKEN"
          />
          <v-text-field
            v-model="form.expected_clamps.value.value"
            :error-messages="form.expected_clamps.errorMessage.value"
            label="Expected clamps"
          />
          <DurationPicker
            v-model="form.autodrop_max_interval.value.value"
            show-enable
          >
            Delete data older than X time
          </DurationPicker>
          <DurationPicker
            v-model="form.autosave_min_interval.value.value"
            show-enable
          >
            Save data only every X time
          </DurationPicker>
          <v-textarea
            v-model="form.note.value.value"
            :error-messages="form.note.errorMessage.value"
            label="Note"
          />
        </v-card-text>
        <v-card-actions class="justify-end">
          <v-btn type="reset">Reset</v-btn>
          <v-btn type="submit">Submit</v-btn>
        </v-card-actions>
      </v-form>
    </v-card>
  </PanelPage>
</template>

<script setup>
import PanelPage from "../components/PanelPage.vue";
import DurationPicker from "../components/DurationPicker.vue";
import { ref } from "vue";
import { useForm } from 'vee-validate';
import * as yup from 'yup';
import { getFormFromSchema } from "../utils.js";
import { createIpsum } from "../remote/ipsum.js";

// State
const useAlerts = ref(null);
const loadingOverlay = ref(false);

// Validation Schema
const schema = yup.object({
  alias: yup.string().required(),
  token: yup.string().required(),
  expected_clamps: yup.number().integer().moreThan(0).required(),
  autodrop_max_interval: yup.string().nullable(),
  autosave_min_interval: yup.string().nullable(),
  note: yup.string().notRequired(),
});

const { handleSubmit, handleReset } = useForm({
  validationSchema: schema,
  initialValues: {}
});

const form = getFormFromSchema(schema);

// noinspection JSValidateTypes
const submit = handleSubmit(async (values) => {
  let payload = {
    alias: values['alias'],
    token: values['token'],
    expected_clamps: values['expected_clamps'],
    autodrop_max_interval: values['autodrop_max_interval'],
    autosave_min_interval: values['autosave_min_interval'],
    note: values['note'],
  };
  console.log(payload);
  loadingOverlay.value = true;
  // Create IPSUM
  try {
    await createIpsum(useAlerts, payload);
  } catch (e) {
    useAlerts.value.errorAlert("Error during Ipsum creation", e.toString());
  } finally {
    loadingOverlay.value = false;
  }
});

</script>

<style scoped>

</style>
